import { GridColDef } from "@mui/x-data-grid";
import PreferencesDetailButton from "./DetailButton";

export const preferencesColumns: GridColDef[] = [
    {
        field: '',
        renderCell: PreferencesDetailButton,
        width: 150,
        headerName: '',
        sortable: false,
        filterable: false,
    },
    {
        field: 'orderNo',
        headerName: 'Sıra No',
        flex: 1,
        minWidth: 80,
    },
    {
        field: 'cityCode',
        headerName: 'Şehir',
        flex: 1,
        minWidth: 80,
        valueGetter: (v, r) => r.city?.cityName
    },
    {
        field: 'branch',
        headerName: 'Branş',
        flex: 1,
        minWidth: 80,
    },
    {
        field: 'unitName',
        headerName: 'Birim Adı',
        flex: 2,
        minWidth: 80,
    },
    {
        field: 'availableSlots',
        headerName: 'Münhal Sayısı',
        flex: 1,
        minWidth: 80,
    },
    {
        field: 'description',
        headerName: 'Açıklama',
        flex: 1,
        minWidth: 80,
    },
];